import { render, staticRenderFns } from "./AgentCommissionList.vue?vue&type=template&id=d8924732&scoped=true"
import script from "./AgentCommissionList.vue?vue&type=script&lang=js"
export * from "./AgentCommissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8924732",
  null
  
)

export default component.exports